import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy
} from '@angular/core';
import { Store, select } from '@ngrx/store';
import {
  ResetPasswordRequest,
  SuccessStore,
  SendResetPasswordEmail,
  LoginRedirect,
  VerificationCodeRedirect,
  AuthActionTypes,
  ResetPasswordStore
} from '@arc/arc-shared-frontend';
import { SubSink } from 'subsink';
import { filter, map } from 'rxjs/operators';

@Component({
  selector: 'app-authentication-forgotpassword-container',
  templateUrl: './forgotpassword.container.component.html'
})
export class ForgotPasswordContainerComponent implements OnInit, OnDestroy {
  email$;

  @Input() fromExternal;

  @Output()
  verificationEmailSent = new EventEmitter<any>();

  @Output()
  gotoVerificationCodeClicked = new EventEmitter<any>();

  @Output()
  goBackClicked = new EventEmitter<any>();

  private subs = new SubSink();
  constructor(private store: Store<any>) {}

  ngOnInit() {
    this.email$ = this.store.pipe(
      select(ResetPasswordStore),
      map(x => x.email)
    );
    this.subs.add(
      this.store
        .select(SuccessStore)
        .pipe(
          filter(
            x => x && x.actionType === AuthActionTypes.SendResetPasswordEmail
          )
        )
        .subscribe(x => {
          this.verificationEmailSent.emit();
        })
    );
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  onResetPassword(email: string) {
    this.store.dispatch(
      new SendResetPasswordEmail({
        email: email,
        from: this.fromExternal
      } as ResetPasswordRequest)
    );
  }

  onGoBack() {
    this.goBackClicked.emit();
    this.store.dispatch(new LoginRedirect(null));
  }

  onGoToVerificationCode() {
    this.gotoVerificationCodeClicked.emit();
    this.store.dispatch(new VerificationCodeRedirect(false));
  }
}
